import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AddCall } from 'src/providers/addvCall';


@Component({
  selector: 'app-rating-sortpage',
  templateUrl: './rating-sortpage.page.html',
  styleUrls: ['./rating-sortpage.page.scss'],
})
export class RatingSortpagePage implements OnInit {
  frm : any;
  constructor(
    private modelCtrl : ModalController,
    public addCall: AddCall,
  ) { }

  ngOnInit() {
    console.log(this.frm);
    
  }

  dismiss(){
    console.log('dismiss');
    
    this.modelCtrl.dismiss({

    })
  }
  Sltorder(orderwise,ordername){
    console.log(orderwise,ordername);
    
    this.modelCtrl.dismiss({
      orderWise : orderwise,
      orderby : ordername
    })
  }




}
